<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [modalContainerAutomationId]="modalContainerAutomationId" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="ok()" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="modalHelpIndex" [resizeHorizontal]="true"
    [resizeVertical]="true" [resizeHorizontalMin]="700" [resizeVerticalMin]="500" [buttonTemplate]="textInfoTemplate">

    <span class="templateHeader">
        <p> Select Template</p>
    </span>
    <div class="templates-row">
        <ul class="nav nav-tabs template-tabs">
            <li [hidden]="hideProjectTemplates" [ngClass]="{'active': templateTab === 'project' }"
                id="projectTemplatesId" [attr.data-automation-id]="modalAutomationId + '-project-templates-button'"
                (click)="setTemplateTab('project')">
                <a>Project Templates</a>
            </li>
            <li [ngClass]="{'active': templateTab === 'organization' }" id="orgTemplatesId" *ngIf="hasOrgPermissions"
                [attr.data-automation-id]="modalAutomationId + '-organization-templates-button'"
                (click)="setTemplateTab('organization')">
                <a>Organization Templates</a>
            </li>
            <li *ngIf="!hideSysTemplates && hasSysPermissions" [ngClass]="{'active': templateTab === 'system' }"
                id="sysTemplatesId" [attr.data-automation-id]="modalAutomationId + '-system-templates-button'"
                (click)="setTemplateTab('system')">
                <a>System Templates</a>
            </li>
        </ul>
        <div class="content">
            <div *ngIf="templateTab === 'project'" class='templateContent'>
                <ng-container *ngTemplateOutlet="newTemplateButton"></ng-container>
                <div *ngFor='let template of projectProfiles; index as i' (click)="setSelectedTemplate(template)"
                    [attr.data-automation-id]="'save-to-load-from-template-project-template-' + template.name">
                    <div [ngClass]="[template === selectedTemplate ? 'selected' : '']" class="template-item">
                        <i class="fa fa-sticky-note color-blue-01 template-icon"></i>
                        <label for="{{'template-' + i}}"
                            [attr.data-automation-id]="'save-to-load-from-project-template-label'"
                            class="template-item-label">{{ template.name }}</label>
                        <label class="defaultLabel" *ngIf="template.defaultTemplate"
                            for="{{'template-' + i}}">Default</label>
                    </div>
                </div>
            </div>
            <div [hidden]="templateTab !== 'organization'" class="templateContent">
                <ng-container *ngTemplateOutlet="newTemplateButton"></ng-container>
                <div *ngFor='let template of orgTemplates; index as i' (click)="setSelectedTemplate(template)"
                    [attr.data-automation-id]="'save-to-load-from-template-org-template-' + template.name"
                    [hidden]="isSystemContext">
                    <div [ngClass]="[template === selectedTemplate ? 'selected' : '']" class="template-item">
                        <i class="fa fa-sticky-note color-yellow-07 template-icon"></i>
                        <label for="{{'template-' + i}}" [attr.data-automation-id]="orgTemplatesAutoIdPrefix +'-label'"
                            class="template-item-label">{{ template.name }}</label>
                        <label class="defaultLabel" *ngIf="template.defaultTemplate"
                            for="{{'template-' + i}}">Default</label>
                    </div>
                </div>
                <res-generic-tree #orgTemplatesInSystemContext [hidden]="!isSystemContext"
                    [automationId]="'save-to-load-from-template-org-template'"
                    [finishLoadingCallback]="finishLoadingTreeDataCallback"
                    [selectedNodeChangedCallback]="selectedNodeChangedCallback">
                </res-generic-tree>
            </div>
            <div *ngIf="templateTab === 'system'" class='templateContent'>
                <ng-container *ngTemplateOutlet="newTemplateButton"></ng-container>
                <div *ngFor='let template of sysTemplates; index as i' (click)="setSelectedTemplate(template)"
                    [attr.data-automation-id]="'save-to-load-from-template-system-template-' + template.name">
                    <div [ngClass]="[template === selectedTemplate ? 'selected' : '']" class="template-item">
                        <i class="fa fa-sticky-note color-purple-03 template-icon"></i>
                        <label for="{{'template-' + i}}"
                            [attr.data-automation-id]="'save-to-load-from-system-template-label'"
                            class="template-item-label">{{ template.name }}</label>
                        <label class="defaultLabel" *ngIf="template.defaultTemplate"
                            for="{{'template-' + i}}">Default</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template #newTemplateButton>
        <div class="new-template" *ngIf="newTemplateVisible && (!isSystemContext || templateTab === 'system')"
            [attr.data-automation-id]="modalAutomationId + '-new-template-button'" (click)="newTemplate()">
            <i class="fa fa-plus new-template-icon"></i>
            <span class="new-template-text">New Template...</span>
        </div>
    </ng-template>
    <ng-template #textInfoTemplate>
        <span *ngIf="isWorkflowSaveToTemplate" class="button-bar-info-text">A copy of the workflow including the Initial Search Target<br> and any Tags/Folders will be added to the selected<br> template.</span>
    </ng-template>
</res-base-modal>